import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EMOJI_PICKER_TRANSLATION, EMOJI_PICKER_TRANSLATION_EN } from '../constants/emoji-picker-translation';

@Injectable({
    providedIn: 'root',
})
export class EmojiHelper {
    constructor(private readonly translate: TranslateService) {}

    getTranslations() {
        return this.translate.currentLang.indexOf('fr') !== -1 ? EMOJI_PICKER_TRANSLATION : EMOJI_PICKER_TRANSLATION_EN;
    }
}
